var r = ["http://", "https://", "mailto:"];

function e(t) {
  return r.some(function (o) {
    return t.startsWith(o);
  }) ? t : "http://".concat(t);
}

export { e as tryPrependProtocol };